import { ApplicationParticipant } from '@/config/types';

import { setPageStateById } from '../PageContext';

export const setApplicationParticipant =
  (setState: setPageStateById) => (applicationParticipant: ApplicationParticipant) => {
    setState('SET_PARTICIPANT', (s) => ({
      ...s,
      applicationParticipant,
    }));
  };
